import { Component, Input, OnInit } from '@angular/core';
import { AlertService, DeliveryStoreService, IAlertType } from "../../../../_shared/services";
import { Delivery, StatusButtons } from '../../../../_shared/interfaces';
import { ClrDatagridModule, ClrDatagridSortOrder, ClrIconModule, ClrLoadingModule } from '@clr/angular';
import { DatePipe, NgIf } from "@angular/common";
import { RouterLink } from "@angular/router";
import { JobDetailsDeliveriesComponent } from "../job-details-deliveries/job-details-deliveries.component";
import { ClarityIcons, exclamationCircleIcon, exclamationTriangleIcon, infoCircleIcon } from "@cds/core/icon";

@Component({
  selector: 'app-job-details-delivery',
  standalone: true,
  imports: [
    ClrDatagridModule,
    NgIf,
    RouterLink,
    ClrIconModule,
    DatePipe,
    JobDetailsDeliveriesComponent,
    ClrLoadingModule
  ],
  templateUrl: './job-details-delivery.component.html',
  styleUrl: './job-details-delivery.component.sass'
})

export class JobDetailsDeliveryComponent implements OnInit {

  deliveries: Delivery[] = [];
  descSort = ClrDatagridSortOrder.DESC;
  loading: boolean = true;
  statusLabel = 'alert-info';
  statusText = '';
  statusIcon = 'info-circle';

  @Input() projectId: string = '';
  @Input() jobId: number = 0;

  constructor(
    private delss: DeliveryStoreService,
    private alertDispatcher: AlertService,
    ) {
    ClarityIcons.addIcons(infoCircleIcon, exclamationCircleIcon, exclamationTriangleIcon)
  }

  ngOnInit(): void {
    this.loading = true;
    this.loadList();
  }

  statusButtons: StatusButtons[] = [
    { state: 'open',   display: 'Offen',   label: 'alert-info',    icon: 'info-circle'},
    { state: 'closed', display: 'Gebucht', label: 'alert-success', icon: 'check-circle'},
    { state: 'noinvoice', display: 'Ohne Rechnung', label: 'alert-warning', icon: 'exclamation-triangle'}
  ];

  // Anpassung Farbe und Text des Statusbuttons...
  findButtonStatus(projectstatus: string, buttons: StatusButtons[]) {
    return buttons.findIndex(el => el.state === projectstatus)
  };

  getCellStatus(invoicestatus: string) {
    // findButtonStatus liefert -1, wenn der Status unbekannt ist -- ein
    // direkter Zugriff darauf wirft und reisst die ganze Tabelle mit. Genau so
    // blieb der Lieferschein-Reiter leer bzw. im Ladekreis haengen, als das
    // Vokabular um einen Status erweitert wurde, den diese Liste nicht kannte.
    const treffer = this.statusButtons[this.findButtonStatus(invoicestatus, this.statusButtons)];
    return treffer?.label ?? 'label-light-blue';
  }

  loadList() {
    this.delss.getDelivery(this.projectId, 0, this.jobId, 'all').subscribe({
      next: data => {
        if (!data || !data.object || data.object.length === 0) {
          this.alertDispatcher.alertConfig.message = 'Keine Orderdaten gefunden!';
          this.alertDispatcher.alertConfig.clrAlertType = IAlertType.WARNING;
          return;
        }

        this.deliveries = data.object;
      },
      complete: () => {
        this.loading = false;
        this.descSort = ClrDatagridSortOrder.DESC;
      }
    });
  }

  findButtonClass(invoicestatus: string) {
    return "alert " + this.getCellStatus(invoicestatus) + " alert-sm";
  }
}
